import { LegalPage } from '../components/LegalPage';

/**
 * Terms of Service. Drafted for the pilot. Same caveat as the privacy
 * page: review and tailor before the first outside-institution pilot
 * if legal asks for different wording.
 */
export function Terms() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="2026-05-23">
      <p>By signing in to LessAlone you agree to these terms. They are short on purpose.</p>

      <h2>Who can use LessAlone</h2>
      <ul>
        <li>You are 18 or older.</li>
        <li>
          You belong to a community (university, employer, or other organization) that has licensed
          LessAlone for its members. The email you sign in with must verify that belonging.
        </li>
        <li>You are not currently banned from LessAlone for a previous violation.</li>
      </ul>

      <h2>What LessAlone is — and isn't</h2>
      <p>
        LessAlone is a one-to-one text-based peer-connection app for everyday loneliness. It is{' '}
        <strong>not a crisis service</strong> and is not monitored in real time. If you or someone
        you're talking with is in immediate danger, please contact emergency services or call/text
        the 988 Suicide & Crisis Lifeline.
      </p>

      <h2>How to use it</h2>
      <ul>
        <li>Be a person another person would want to talk to.</li>
        <li>Keep things in the app — don't pressure a peer to move to another platform.</li>
        <li>
          Don't share another member's identity, photos, real name, or anything they shared with you
          in a different setting.
        </li>
        <li>
          No harassment, slurs, sexual content, content involving minors, attempts at fraud, or
          content meant to flame or destabilize someone.
        </li>
        <li>
          If something feels wrong, use the "Report this conversation" action — a moderator will see
          it.
        </li>
      </ul>

      <h2>What we may do</h2>
      <p>
        We may pause, suspend, or remove an account that violates these terms or the community
        guidelines, with or without prior warning, depending on the severity of the violation. We
        log every moderator action in an append-only audit trail.
      </p>

      <h2>Liability</h2>
      <p>
        LessAlone is provided as-is. We make every effort to keep it safe, but we cannot guarantee
        outcomes from any conversation. You are responsible for your own well-being and for using
        emergency resources when appropriate.
      </p>

      <h2>Changes to these terms</h2>
      <p>
        If we update these terms, we'll let active members know via email and bump the "Last
        updated" date above. Continued use after a change is acceptance of the new terms.
      </p>
    </LegalPage>
  );
}
